import React, { useState } from "react";
import "../css/Login.css";
import { Container, Box, CssBaseline, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import logo from "../images/flyins-logo.svg";
import email from "../images/email.svg";

const useStyles = makeStyles((theme) => ({
  insidePaper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  main: {
    marginTop: theme.spacing(7),
    fontFamily: "Inter",
  },
  paper: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      padding: theme.spacing(4),
    },
  },
  title: {
    fontWeight: 500,
    fontSize: 40,
    color: "#212529",
    textAlign: "center",
  },
  body: {
    fontSize: 16,
    fontWeight: 400,
    color: "#495057",
    margin: "12px 0 20px 0",
    textAlign: "center",
  },
  subbody: {
    fontSize: 16,
    fontWeight: 400,
    color: "#495057",
    textAlign: "center",
    maxWidth: 723,
    margin: "auto",
  },
  resendEmail: {
    marginTop: 40,
    fontSize: 16,
    fontWeight: 400,
    color: "#495057",
    textAlign: "center",
    maxWidth: 723,
    margin: "auto",
  },
  successMessage: {
    color: "green",
    fontSize: "14px",
    textAlign: "center",
  },
  errorMessage: {
    color: "red",
    fontSize: "14px",
    textAlign: "center",
  },
}));

const VerifyEmail = ({
  userEmail = "username@email.com",
  resendEmailCallBack,
}) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const classes = useStyles();

  const handleResendEmail = async () => {
    setLoading(true);
    setMessage("");

    try {
      const response = await resendEmailCallBack(); // Call the function passed as prop (submitCreateAccount)

      if (response && response.data.success) {
        setMessage("Verification email resent successfully!");
      } else {
        setMessage(response?.data?.error);
      }
    } catch (error) {
      setMessage("An error occurred while resending the email.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Container
        component="main"
        maxWidth="xs"
        className={clsx(classes.main, "form-style")}
      >
        <CssBaseline />
        <Box
          maxWidth="xs"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <img
            src={logo}
            alt="flyins"
            width="307"
            height="100"
            draggable={false}
          />
        </Box>

        <div className={classes.paper}>
          <Paper elevation={2} style={{ margin: "auto" }}>
            <img
              src={email}
              alt="flyins"
              width="96"
              height="96"
              draggable={false}
            />
          </Paper>
        </div>
        <div className={classes.title}>Verify your email</div>
      </Container>
      <div className={classes.body}>
        You will need to verify your email to complete the registration.
      </div>
      <div className={classes.subbody}>
        An email has been sent to{" "}
        <span style={{ fontWeight: 700 }}>{userEmail}</span> with a link to
        verify your account. If you have not received the email after a few
        minutes, please check your spam folder.
      </div>
      <div className={classes.resendEmail}>
        Didn’t receive the email?{" "}
        <span
          onClick={handleResendEmail}
          style={{
            color: "#5046B2",
            fontWeight: 600,
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Resending..." : "Click to resend"}
        </span>
        {message && (
          <div
            className={
              message.includes("successfully")
                ? classes.successMessage
                : classes.errorMessage
            }
          >
            {message}
          </div>
        )}
      </div>
    </>
  );
};

export default VerifyEmail;
